import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartPageComponent } from './___COMPONENTS/___Pages/start-page/start-page.component';
import { ClientInteractionsComponent } from './___COMPONENTS/__crmTools/client-interactions/client-interactions.component';
import { ClientProfileComponent } from './___COMPONENTS/___Pages/client-profile/client-profile.component';
import { ClientBoardComponent } from './___COMPONENTS/client-board/client-board.component';
import { EmailComposerComponent } from './___COMPONENTS/__crmTools/email-composer/email-composer.component';
import { HomeComponent } from './___COMPONENTS/___Pages/home/home.component';
import { CrudComponent } from './___COMPONENTS/__crud/crud/crud.component';
import { BachLegalClientsComponent } from './___COMPONENTS/__collabs/bach-legal-clients/bach-legal-clients.component';
import { OmnibusClientsComponent } from './___COMPONENTS/__collabs/omnibus-clients/omnibus-clients.component';
import { BudgetsComponent } from './___COMPONENTS/__crmTools/__budgets/budgets/budgets.component';
import { PackageBuilderComponent } from './___COMPONENTS/__crmTools/__budgets/package-builder/package-builder.component';
import { ShopifyOrdersComponent } from './___COMPONENTS/__shopify/shopify-orders/shopify-orders.component';
import { LoginPageComponent } from './___COMPONENTS/___Pages/login-page/login-page.component';
import { VisaPipelineComponent } from './___COMPONENTS/__subapps/visa-pipeline/visa-pipeline.component';
import { SupermarketHelperComponent } from './___COMPONENTS/supermarket-helper/supermarket-helper.component';
import { BudgetBuilderComponent } from './___COMPONENTS/__crmTools/__budgets/budget-builder/budget-builder.component';
import { ClientManagerComponent } from './___COMPONENTS/__crmTools/client-manager/client-manager.component';
import { StudyHelperComponent } from './___COMPONENTS/study-helper/study-helper.component';

import { RequirementListComponent } from './___COMPONENTS/requirement-list/requirement-list.component';
import { RequirementDetailComponent } from './___COMPONENTS/requirement-detail/requirement-detail.component';
import { ClientProcessComponent } from './___COMPONENTS/client-process/client-process.component';
import { ShopifySimulatorComponent } from './___COMPONENTS/__shopify/shopify-simulator/shopify-simulator.component';
import { WebappManagerComponent } from './___COMPONENTS/__crmTools/webapp-manager/webapp-manager.component';
import { FileManagerComponent } from './___COMPONENTS/__crmTools/file-manager/file-manager.component';
import { AuthGuard } from './___LOGIC/__guards/auth.guard';
import { ClientBoardResolver } from './___LOGIC/resolvers/client-board.resolver';
import { BudgetsResolverService } from './___LOGIC/resolvers/budgets.resolver';
import { CrudDynamicComponent } from './___COMPONENTS/crud-dynamic/crud-dynamic.component';
import { CalendlyManagerComponent } from './___COMPONENTS/calendly-manager/calendly-manager.component';
import { SettingsPageComponent } from './___COMPONENTS/settings-page/settings-page.component';


const routes: Routes = [
  // PAGES
  {path: 'login', component: LoginPageComponent},
  {path: 'home', component: HomeComponent, canActivate: [AuthGuard]}, // for all users
  // CRM
  {path: 'start', component: StartPageComponent, canActivate: [AuthGuard]},
  {path: 'client-board', component: ClientBoardComponent, canActivate: [AuthGuard],resolve: {
    clientBoard: ClientBoardResolver
  }}, 
  {path: 'client-manager', component: ClientManagerComponent, canActivate: [AuthGuard]}, // Client list view
  {path: 'webapp-manager', component: WebappManagerComponent, canActivate: [AuthGuard] }, // Users in app
  {path: 'client-interactions/:id', component: ClientInteractionsComponent, canActivate: [AuthGuard]},
  {path: 'crud', component: CrudComponent, canActivate: [AuthGuard]},

  // Profile
  {path: 'profile/new', component: ClientProfileComponent, canActivate: [AuthGuard]},
  {path: 'profile/edit/:id', component: ClientProfileComponent, canActivate: [AuthGuard]},
  {path: 'email-composer', component: EmailComposerComponent, canActivate: [AuthGuard]},
  // ADMIN
  {path: 'settings', component: SettingsPageComponent, canActivate: [AuthGuard]},

  {path: 'package-builder', component: PackageBuilderComponent, 
    canActivate: [AuthGuard],
    resolve: {
      productList: BudgetsResolverService
    }
  },
  {path: 'budget-builder', component: BudgetBuilderComponent , canActivate: [AuthGuard]},
  {path: 'budget-manager', component: BudgetsComponent,
    canActivate: [AuthGuard],
    resolve: {
      budgetsInfo: BudgetsResolverService
    }
  },
  // STUDY
  {path: 'visa-helper', component: VisaPipelineComponent, canActivate: [AuthGuard]},
  {path: 'study-helper', component: StudyHelperComponent, canActivate: [AuthGuard]},
  // LIFE IN SPAIN
  {path: 'supermarket-helper', component: SupermarketHelperComponent, canActivate: [AuthGuard]},
  // CLIENT PROCESS CONTROL
  {path: 'client-process', component: ClientProcessComponent, canActivate: [AuthGuard]},
  // CALENDLY
  {path: 'calendly-manager', component: CalendlyManagerComponent, canActivate: [AuthGuard]},
  // REQS
  {path: 'req-list', component: RequirementListComponent, canActivate: [AuthGuard]},
  {path: 'requirement-step', component: RequirementDetailComponent, canActivate: [AuthGuard]},

  // COLLABS
  {path: 'om-dashboard', component: OmnibusClientsComponent}, /* , canActivate: [AuthGuard] */
  {path: 'bach-legal-dashboard', component: BachLegalClientsComponent, canActivate: [AuthGuard]},
  //SHOPIFY
  {path: 'shopify-orders', component: ShopifyOrdersComponent, canActivate: [AuthGuard]},
  {path: 'shopify-simulator', component: ShopifySimulatorComponent,canActivate: [AuthGuard]}, /*  */
  {path: 'files', component: FileManagerComponent, canActivate: [AuthGuard]}, /* ,canActivate: [AuthGuard] */

  //CRUD
  {path: 'crud/:table', component: CrudDynamicComponent, canActivate: [AuthGuard]}, /* ,canActivate: [AuthGuard] */

  { path: '**', redirectTo: 'login' }, // Catch-all redirect (optional)

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
